import React from 'react'

type FIInfinityIconProps = {
  width?: number
  height?: number
  className?: string
}

export const FIInfinityIcon: React.FC<FIInfinityIconProps> = ({
  width = 40,
  height = 20,
  className,
}) => {
  return (
    <svg
      className={className}
      width={width}
      height={height}
      viewBox="0 0 85.9 42.9"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <defs>
        <linearGradient
          id="fiInfinityGradient"
          x1="2.6"
          y1="21.4"
          x2="83.3"
          y2="21.4"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stopColor="#B973FF" />
          <stop offset="0.4" stopColor="#759AF3" />
          <stop offset="1" stopColor="#00E0E0" />
        </linearGradient>
      </defs>
      <path
        d="M83.3,21.4c0,10.4-8.4,18.8-18.8,18.8-5,0-9.8-2-13.3-5.5h-.1c0-.1-20.1-22.9-20.1-22.9-5.3-5.2-13.8-5.2-19,.1-5.2,5.3-5.2,13.8.1,19,5.2,5.2,13.7,5.2,18.9,0l2.9-3.2c1-1.1,2.7-1.2,3.8-.2s1.2,2.7.2,3.8l-2.9,3.3h-.1c-7.3,7.5-19.3,7.5-26.6.1-7.3-7.3-7.3-19.3,0-26.6,7.3-7.3,19.3-7.3,26.6,0h.1c0,.1,20.1,22.9,20.1,22.9,5.3,5.2,13.8,5.2,19-.1,5.2-5.3,5.2-13.8-.1-19-5.2-5.2-13.7-5.2-18.9,0l-2.9,3.2c-1,1.1-2.7,1.2-3.8.2-1.1-1-1.2-2.7-.2-3.8l2.9-3.3h.1c7.3-7.5,19.3-7.5,26.6-.1,3.5,3.5,5.5,8.3,5.5,13.3Z"
        fill="url(#fiInfinityGradient)"
      />
    </svg>
  )
}
